<div class="notifications mat-elevation-z8">
    <div class="notifications__header">
        Notifications
    </div>
    <div class="notifications__content">
        <div class="notify" fxLayout="column" *ngFor="let notification of notifications">
            <div fxLayout="row" fxLayoutAlign="start center">
                <div fxFlex="15">
                    <mat-icon class="material-icons-outlined"
                                [ngClass]="{ green: notification.NotificationTypeID === 3,
                                 warn: notification.NotificationTypeID === 2,
                                 red: notification.NotificationTypeID === 1}">
                        {{ notification.IconCode }}
                    </mat-icon>
                </div>
                <div fxFlex="70" class="notify__title">
                    <b>{{ notification.NotificationSubject }}</b>
                </div>
                <div fxFlex="15" fxLayoutAlign="end center" class="notify__close">
                    <button class="dismiss" mat-icon-button
                            [disabled]="loading"
                            (click)="dismissNotification(notification)">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>
            <div class="notify__desc" fxLayout="row" fxLayoutAlign="start center">
                {{ notification.NotificationDescription }}
                <a class="click-here" *ngIf="notification.NotificationLink" (click)="redirectNotification(notification)">Click here</a>
            </div>
            <div fxLayout="row" fxLayoutAlign="end center" class="notify__time">
                {{ parseDateFormat(notification.CreateDate) }}
            </div>
        </div>
    </div>
</div>
